import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { localeGuard, legacyPaginationGuard, legacyTypeQueryGuard } from './guards'

/**
 * Vue Router instance
 * - History mode (без #)
 * - Locale guard для проверки локали
 * - Scroll behavior для навигации
 */
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0 }
  },
})

// DEV-190/DEV-222: редиректы legacy query → path-сегменты (до locale-guard).
router.beforeEach(legacyPaginationGuard)
router.beforeEach(legacyTypeQueryGuard)

// Глобальный guard для локали
router.beforeEach(localeGuard)

export default router
